const TOPIC = {
  API: {
    LOADING: 'api_loading',
    ERROR: 'api_error',
    GLOBAL_ERROR: 'api_global_error',
    SUCCESS: 'api_success',
    COMPLETE: 'api_complete',
    CANCEL: 'api_cancel'
  },
  NOTIFY: {
    SUCCESS: 'notify_success'
  },
  TOKEN: {
    EXTEND_COOKIE: 'token_extend_cookie',
    EXPIRE_COOKIE: 'token_expire_cookie'
  }
};

export {
  TOPIC
};
